import React, { useState } from "react";
import LoadingView from "./loading-view";
import style from './iframe-view.module.scss';

export default function IframeView ({
  url,
  onLoaded,
}: {
  url: string
  onLoaded: () => void
}) {
  const [frameLoading, setFrameLoading] = useState(true);

  const setFrameLoaded = () => {
    if (frameLoading) {
      onLoaded();
    }
    setFrameLoading(false);
  }

  return (
    <>
      <div className={frameLoading ? "" : style.hidden} style={{height: "100%", flex: 1}}>
        <LoadingView />
      </div>
      {url ?
        <iframe
          title='payment'
          src={url}
          className={[frameLoading ? style.hidden : "", style.iframe].join(' ')}
          onLoad={setFrameLoaded}
          id="paywall-payment-iframe"
        />
      : null}
    </>
  )
}
